
export const pt: { [key: string]: { [key: string]: string } } = {
    common: {
        register: "Registro",
        login: "Entrar",
        noData: "Nenhum registro ainda",
        loading: "Loading...",
        myLink: "Meu link:",
        level: "Nível",
        quickShare: "Compartilhamento Rápido",
        pepole: "Pessoas",
        travel: "Dia",
        activityTitle: "Descrição da Atividade",
        deposite: "Depósito",
        sake: "Saque",
        loadMore: "Carregar mais",
        times: "vezes",
        bets: "Apostar",
        paymentChannel: "Canal de pagamento",
        inprogress: "Em andamento",
        ok: "OK",
        title:"365GG.COM",
        ios:"IOS",
        android: "Android",
        days: "dias",
        hours:"horas",
        copied:"foi copiado",
        more:"Mais",
        NoMoreData:"Não mais",
        notCompleted : "Não cumprido",
        promotion:"Promoção",
        rechargeTotal: "Recarregue hoje",
        loss:"Perda",
        home:"Hall",
        agente:"Agência",
        profile:"Perfil",
        return:"Retorno",
        profit : "Ganhar",
        history:"História"
    },
    accFund: {
        mainTitle:"Fundo de Acumulação",
        invest: "Investir",
        andGet: "e obter",
        rewardPlan: "Plano de recompensa",
        time: "Tempo",
        amountReceived: "Montante Recebido",
        gameFlow: "Fluxo do Jogo",
        title: "Technology is nothing more than the common soul of those who develop it.",
    },
    bauDoTesouro: {
        treasure: "Baú do Tesouro",
        myReports: "Meus subordinados diretos"
    },
    agent: {
        validBets: "Apostas válidas",
        lowerLevelTeam: "Equipe de nível inferior",
        rollover: "Rollover",
        commission: "comissão",
        faqTitle1: "O que é o programa de afiliados",
        faqTitle2: "QUANTO CUSTA PARA PARTICIPAR?",
        faqTitle3: "Posso obter benefícios mesmo se não tiver um site?",
        faqTitle4: "QUANTO EU GANHO?",
        faqContent1: "Afiliados é um programa onde oferecemos a você a oportunidade de ganhar dinheiro todos os dias, simplesmente nos dando a chance de receber mais jogadores.",
        faqContent2: "Absolutamente nada. É totalmente gratuito.",
        faqContent3: "Claro que pode. Podemos fornecer todas as ferramentas de marketing de que você precisa para promover a ",
        faqContent3Sub: "offline nas mídias sociais ou por e-mail.",
        faqContent4: "Como parte da nossa rede de afiliados, você será pago em um modelo de compartilhamento de receita. Você ganha mais de 80% de recompensa de comissão.",
        definition: "Definição",
        definitionContent: "Aposta válidas em equipe [num] - Total de valor de apostas válidas provenientes de indicações e contribuições de suas equipes. num - Número total de indicações e membros de suas equipes que contribuíram com apostas válidas.",
        graphCardTitle: "Desenvolvimento ilimitado dos subordinados",
        graphCardContent1: "1. Você receberá uma porcentagem de comissão diferente toda vez que um jogador indicado por você fizer uma aposta,",
        graphCardContent2: "ganhar ou perder.",
        graphCardContent3: "2. O sistema calcula a comissão a cada 3 minutos.",
        directCommission: "Comissões diretas",
        teamCommission: "Comissões equipe",
        teammRollover: "Rollover equipe",
        propotion: "Proporção",
        directRegistration:"Registro Direto",
        commissionTeam:"Comissão da equipe",
        invitation:"Convite",
        myData:"Os meus dados",
        faq:"FAQ",
        detailed:"Detalhado",
        directRechargeCommision : "Comissão de recarga direta",
        directBettingCommission:"Comissão de Apostas Diretas",
        commissionRate:"Taxa de comissão",
        totalCommission:"Registro de Aposta Total",
        directPlayer:"Jogador direto"
    },
    rulecard: {
        communicationRules: "Regras de cálculo de comissão",
        faqHead1: "O C3 é poderoso e também possui",
        faqHead2: "/milhões",
        perfoTitle1: "Desempenho total 3,31M, Bônus total do agente",
        perfoTitle2: "Desempenho de subordinado 180K, Contribuiu",
        perfoTitle3: "Outro desempenho 3,13M, Contribuir",
        tipText1: "Contribuição de B1",
        tipText2: "Outras contribuições de C1 e C2",
        tipText3: "Contribuir para",
        tipText4: "Outras contribuições de C3",
        tipText5: "Contribuição de B3",
        subAgentWins: "Subagente ganha, geralmente",
        noProfit: "B2 não tem subordinados, por isso não tem lucros",
        wins: "Muito bem subagente, ganhou",
        exampleTitle: "Por exemplo:",
        exampleTitle2: "Por conseguinte, o bônus é calculado da seguinte forma:",
        exampleContent: `Neste website o bônus do agente é calculado por apostas. Por exemplo, se as apostas forem 10-200000,
                    a taxa de bônus correspondente será 70/10000, e se as apostas forem superiores a 3000000, o bônus de
                    agente é 110/10000. A é o agente do website, ele recruta B1, B2 e B3 como seus agentes e B1 também
                    recruta C1 e C2 como seus agentes. B2 não tem agentes e B3 tem apenas um agente C3. Alguns dias
                    depois, a aposta efetiva do próprio B1 é de 120.000, a aposta efetiva de B2 é de 40.000, as apostas
                    efetivas de B3 são 20.000, as apostas efetivas do C1 são 100.000, as apostas efetivas do C2 são
                    30.000, C3 Eu tenho 3 milhões de apostas eficazes, Em seguida, o desempenho total de B1 vem de
                    130.000 de C1 e C2, e a taxa de retorno da comissão correspondente é 70/10.000; B2 não tem
                    desempenho subordinado 0; a taxa de retorno da comissão é 110/10.000; a tem 180.000 do Equipe direta
                    e 3,13 milhões de outras equipes, com um desempenho total de 3,31 milhões, e a taxa de retorno
                    correspondente é 110/10.000.`,
        exampleContent2: "1. Equipe direta: refere-se aos membros do desenvolvimento vertical, que são coletivamente chamados \
                    de Equipe direta. <br> \
                    (1) B1, B2, B3 contribuem para A: (120000 + 40000 + 20000) x 110/10000 = 1980.<br> \
                    (2) C1 e C2 contribuem para B1: (100000 + 30000) x 70/10000 = 910.<br> \
                    (3) C3 contribui para B3: 3 milhões x 110/10000 = 33000.<br><br> \
                    2. Outras equipes: refere-se aos membros do desenvolvimento de subordinados, subordinados, etc., que \
                    são coletivamente chamados de outras equipes; porque este sistema pode desenvolver subordinados \
                    indefinidamente, para melhor compreensão, este artigo apenas toma como exemplo uma estrutura de 2 \
                    níveis.<br> \
                    (1) De C1 e C2: Visto que o desempenho total de B1 é de 130000, tem apenas uma taxa de desconto de \
                    70/10000, enquanto que o desempenho total de A é de 3,31 milhões, e tem uma taxa de desconto de \
                    110/10000. Então a diferença de desconto entre A e B1 é de: 110-70=40, esta diferença é a parte \
                    contribuída por C1 e C2 para A, portanto C1 e C2 contribuem para A: (100000+30000)×40/10000=520.<br> \
                    (2) Outras equipes: refere-se aos membros do desenvolvimento de subordinados, subordinados, etc., \
                    que são coletivamente chamados de outras equipes; porque este sistema pode desenvolver subordinados \
                    indefinidamente, para melhor compreensão, este artigo apenas toma como exemplo uma estrutura de 2 \
                    níveis.<br> \
                    <br> \
                    3. Resumo:<br> \
                    (1) C3 é poderoso, indiretamente permite que todo o desempenho de A desfrute de uma proporção maior \
                    de retornos da comissão.<br> \
                    (2) B2 pode ser preguiçoso, e não tem vantagem se não houver desenvolvimento de subordinados.<br> \
                    (3) Apesar de B3 se ter juntado relativamente tarde e pertencer aos subordinados de A, o seu \
                    subordinado C3 é poderoso, permitindo que B3 desfrute diretamente da mais alta taxa de desconto, e A \
                    não pode ganhar diretamente a diferença de B3. Por isso, de quem é a posição de B3 quando este se \
                    junta? Os benefícios dos subordinados, independentemente do nível em que se encontrem, nunca serão \
                    afetados, deixarão de sofrer as perdas de outros subordinados, e o seu desenvolvimento não será \
                    restringido.<br> \
                    (4) Este é um modelo de agência absolutamente justo, e não prejudicará sempre quem se juntar mais \
                    tarde.<br>"
    },
    myDataView: {
        directCommision: "Comissão direta",
        teamCommission: "Comissão da equipe",
        totalCommssion: "Total das comissões",
        bets: "Apostas diretas",
        teamBets: "Apostas em equipe",
        totalBets: "Total de apostas",
        registration: "Registro direto",
        teamRegistration: "Registro da equipe",
        totalRecords: "Total do registro",
        firstDirectCommission: "Primeiro depósito direto",
        teamsFirstDeposit: "Primeiro depósito da equipe",
        totalInitialDepost: "Total do depósito inicial",
        lastMonth:"Mês passado",
        thisMonth:"Este mês",
        lastWeek:"Semana passado",
        thisWeek:"Esta semana",
        yesterday:"Ontem",
        today:"Hoje",
        recharge: "Recarga direta",
        totalRecharge:"Recarga total"
    },
    bonus: {
        mysterybonus: "Bônus Misterioso",
        registrationTime: "Hora de registro:",
        totalDeposit: "Depósito total de",
        claimTime: "O momento em que os bônus podem ser reclamados:",
        depostiScope: "Âmbito do depósito"
    },
    cashWheel: {
        title: "Receba R$ 100 de graça",
        neccessary: "Ainda é necessário ",
        makeWithdrawal: "para realizar o saque",
        expireIn: "Expira em"
    },
    collect: {
        rechargedMembers: "Membros recarregados podem reivindicar gratuitamente.",
        maximumCachValue: "Valor máximo de queda em dinheiro:",
        depositCollector: "Por favor, colete-o após depositar",
        remainingMaxTIme: "por vez Máx queda",
        perDay: "por dia",
        lineText1: "1.Cada sessão de chuva de dinheiro é distribuída gratuitamente com",
        lineText2: "2.Valor máximo da chuva de dinheiro:",
        lineText3: "3.Membros recarregados podem reivindicar gratuitamente.",
        oopsText: "ope...misko huh hggyfrd"
    },
    deposit: {
        extra: "Extra",
        bonuseRedeem: "Bônus resgatável após",
        invoicing: "faturamento",
        receive: "e receba",
        asaGift: "como presente",
        valueLabel: "valor(10 ~ 50000)",
        promotions:"Participate in promotions"
    },
    funds: {
        rescueFunds: "Fundos de Resgate",
        currentLoss: "Perda Atual",
        plannedFunds: "Fundos de Resgate Previstos",
        gameLoss: "Perda no Jogo",
        redeemFee: "Taxa de Resgate",
        activityContent: "<p>1. Perda no Jogo = Perda na Conta - Montante Dado.<br> \
                    2. Os Fundos de Resgate são calculados diariamente de acordo com a tabela e podem ser solicitados \
                        no dia seguinte.<br> \
                    3. Se um usuário não solicitar os Fundos de Resgate hoje, será considerado como tendo desistido. \
                    <br> \
                    4. O objetivo de estabelecer os Fundos de Resgate é ajudar os usuários a se recuperarem no jogo, \
                        portanto, é necessário um volume de negócios de 1x.<br> \
                    5. Horário brasileiro 00:00 é o horário de liquidação.</p>"
    },
    game: {
        games: "Jogos",
        warm: "Quente",
        lobby: "Lobby"
    },
    gameLog: {
        latestData: "Dados das últimas",
        winOrLoss: "Ganhar ou perder",
        subText: "Por favor, entre em contato com o agente para recarregar as moedas e começar o jogo",
        gameRegistration: "Registro do Jogo",
    },
    giftCode: {
        exchangeReward: "Troca Recompensas",
        pasteText: "Introduza / Colar o código de resgate do cupom",
        pasteInstructions: "*Pressione e segure para colar.",
        activityContent: "1. Insira o código de resgate para receber o bônus em dinheiro.<br> \
                    2. O uso do bônus deve seguir as regras da plataforma.<br> \
                    3. A empresa reserva-se o direito de interpretação final sobre esta atividade.",
        insertPaste:"Introduzir / Colar…"
    },
    level: {
        currentLevel: "Nível atual",
        iron: "Ferro",
        gameTurnOver: "Volume de negócios do jogo nos últimos 7 dias",
        bronze:"Bronze",
        talk:"Prata",
        gold:"Ouro",
        platinum:"platina",
        diamond:"Diamante"
    },
    withdraw: {
        myBalance: "Meu Saldo",
        withdrawalAmount: "Valor do saque",
        valueLabel: "valor(10 ~ 50000)",
        emailErrorText : "Por favor insira um endereço de e-mail com até 36 caracteres",
        cpfErrorText : "Por favor insira 11 dígitos para CPF",
        phoneErrorText : "Por favor, insira 11 dígitos sem o +55 para o seu número de celular.",
        evpErrorText : "EVP não pode estar vazio",
        valueText: "Valor do saque",
        value:"Valor",
        taxIdType:"Tipo de ID Fiscal",
        cpfIdPlaceholder:"Por favor, digite o  CPF ID…",
        emailPlaceholder: "Por favor, digite o  Email ID…",
        phonePlaceholder: "Por favor, digite o  PHONE ID…",
        evpPlaceholder: "Insira o número do EVP",
        userName:"Nome do beneficiário",
        userNamePlaceholder: "Por favor, informe o nome do beneficiário…",
        cpfPlaceholder : "Por favor, digite o  CPF…",
        brazilId :"ID do Brasil",
        brazilIdPlaceholder: "Insira o número de identidade do Brasil",
        bank:"Nome do banco",
        bankPlaceholder:"Insira o nome do banco",
    },
    weeklyCompensation: {
        the: "Das",
        to: "às",
        weeklyCompensation: "Compensação para esta semana",
        title: "Compensação Semanal",
        profit: "Lucro esta semana",
        distribute: "A compensação desta semana será distribuída às",
        available: "Compensação disponível",
        compensation: "Compensação",
        activityContent: "1. A quantidade real de dinheiro perdido multiplicada pela porcentagem de reembolso é o reembolso \
                        daquela semana.<br> \
                    2. Estatísticas independentes de lucros semanais e compensações, lucros anteriores não afetarão \
                        as estatísticas desta semana.<br> \
                    3. A compensação já paga ao cliente não foi cobrada e continuará a acumular-se até que seja \
                        cobrada.<br> \
                    4. Caso você não tenha apostado durante o período em que o cashback estava ativo ou se seus \
                        ganhos da última semana ou ganhos totais são maiores que suas perdas, você não receberá \
                        cashback.<br> \
                    5. O bônus de cashback requer 1 vez o volume efetivo de apostas antes que você possa retirá-lo.<br>"
    },
    vip: {
        title: "VIP",
        receiveBonuses: "Pode receber bônus",
        bettingValue: "Volume acumulado de apostas",
        betVolume: "Volume acumulado de apostas",
        division: "Manter a divisão",
        bets: "Apostas",
        upgradeBonus: "Bônus upgrade",
        weeklyBonus: "Bônus semanal",
        monthlyBonus: "Bônus mensal",
        maintainLevel: "Apostas para manutenção de nível",
        reduceLevel: "Reduzir o nível",
        VIPIncome:"Rendimentos VIP",
        VIPConditions:"Condições VIP"
    },
    offers: {
        promotionContent: "Ainda não chegou o horário da promoção, por favor participe deste evento em",
        win: "Ganhe",
        totaling: "Totalizando",
        demanding: "Exigindo",
        rollover: "de rollover",
        content: "1. No dia da promoção, faça um depósito do valor especificado e receba um grande bônus.<br> \
            2. Todos os jogadores podem participar apenas uma vez e não podem participar repetidamente.<br> \
            3. A promoção começa toda Domingo.",
        sunday: "Domingo",
        hours: "hours",
        minutes: "min",
        seconds: "sec",
        depositReturn:"Grande Retorno de Depósito",
        depositPopText:"Depósito de R$ {recharge}, ganhe R$ {reward}, totalizando "
    },
    profile:{
        configuration:"Configuração do Perfil",
        choosePhoto:"Escolher Nova Foto",
        ContactService:"Contatar o Serviço",
        onlineService:"atendimento online",
        telegram:"Telegram",
        vipBot:"VIP_688V_BOT",
        chat:"Bater papo",
        noteText:'Bem-vindo! Clique em "CHAT" para entrar em contato conosco através do portal de atendimento ao cliente.',
        settings:"Configuração",
        brandName:"Meu Nome de Marca",
        registeredAcc:"Conta registrada",
        password:"Senha",
        withdrawalInfo:"Informações de Saque",
        logout:"Sair da conta",
        id:"ID",
        account:"Conta",
        logoutCurrAcc:"Sair da conta atual?",
        rememberPassword:"Por favor, lembre-se de sua conta de login e senha para fazer login novamente.",
        toLogout:"Sair",
        cancel:"Cancelar",
        enterNickName:"Por favor, digite um apelido",
        passwordSetUp:"Configuração de Senha",
        enterNewPassword:"digite nova senha",
        cnofirmNewPassword:"confirmar nova senha",
        save:"Salvar",
        apostate:"Aposta necessaria",
        followVIP1:"Siga VIP1 Ainda precisa apostar",
        name:"Nome",
        phoneNum:" Número de Telefone",
        email:"Email",
        cpfId:"CPF ID",
        cnpj:"CNPJ ID",
        rapporteurs:"Relatorios",
        toInvite:"Convidar",
        redemptionCode:"Codigo de Resgate",
        support:"Suporte",
        securityCenter:"Centro de Seguranca",
        goOut:"Sair",
        treasureMsg: "Convide 1 pessoa bonus R$ 35"
    },
    message:{
        message:"Mensagem",
        noMore:"Não mais",
        all: "Todos",
        system:"Sistema",
        deposit:"Depósito",
        withdraw:"Saque",
        bonus:"Bônus",
        unread:"Não lido"
    },
    loginRegister:{
        enterPassword:"por favor, insira a senha",
        alreadyAcc:"Registro Já tem uma conta?",
        loginNow:"Entrar agora",
        dontHaveAcc:"Ainda não tens uma conta?",
        registerNow:"Registro-se agora",
        phoneFormat:"Digite um número de telefone correto com 11 dígitos.",
        passwordForamt:"defina uma senha de 8 a 20 dígitos",
        confirmPassword:"confirmar a senha digitada",
        differentPassword:"as senhas são diferentes"
    },
    home:{
        transfer:"Transferir",
        gameLobby:"Game Lobby",
        latestNews:"Últimas Notícias",
        IUnderstand:"Compreendi",
        partners:"Parceiros",
        content:`688V.COM é operado pela 688V N.V, número de registro da empresa 142922, com endereço registrado em
                Zuikertuintjeweg Z/N (Zuikertuin Tower) Curacao e licenciada e autorizada pelo govemo de Curacao. A
                688V.COM opera sob a Master License of Gaming Services Provider, N.V. Número da Licença:GLH-
                OCCHKTW065752688
                <br> <br>
                1. Este produto é para uso de usuários maiores de 18 anos e é destinado apenas para fins de
                entretenimento. <br>
                2. este jogo contém compras noapp. <br>
                3. O fato de um jogador jogar ou ganhar em um jogo de apostas sociais não significa que ele ganhará em
                apostas com dinheiro real e jogos relacionados no futuro. <br>
                <br>`,
        copyright:"©2025 688V.Todos os direitos reservados. 18+",
        version:"ver:1.7.6(1J)",
        noticeContent:"🔥🔥🔥🔥Evento super popular da caixa do tesouro, convide amigos para ganhar R$ 1.000.000. 🎉🎉 Mais bônus estão no 688V , cadastre-se agora🎁🎁\n"
    },
    sideNav:{
        treasure:"Tesouro",
        magnata:"Magnata",
        offers:"Ofertas",
        agent:"Agente",
        VIP:"VIP",
        rescue:"Resgatar",
        mystrey:"Misterioso",
        week:"Semana",
        replacement:"Troca",
        level:"Nível"
    },
    socialMedia:{
        telegram: "Telegram",
        whatsapp: "WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        twitter: "Twitter",
        kwai: "Kwai",
        tiktok: "TikTok"
    },
    report:{
        directReport :"Meus subordinados diretos",
        title:"Condições efetivas do utilizador",
        depositText: "Depósitos acumulados",
        turnOver:"Apostas no jogo",
        subordinate:"Subordenada",
        effective:"Eficaz",
        name: "Nome",
        deposit:"Depósito",
        bets: "Apostas"
    },
    activityName:{
    user_referral_reward:"Tesouro",
        magnata:"Magnata",
        recharge_bargain_sales:"Ofertas",
        agent_cash_back:"Agente",
        vip_reward:"VIP",
        rescue:"Resgatar",
        mystery:"Misterioso",
        week:"Semana",
        replacement:"Troca",
        user_rank:"Nível",
        game_benefit: "Fundos de alívio de perdas",
        first_recharge: "Primeira recarga",
        recharge_gift: "Recarga automática de presente",
        return_turnover: "Limpeza de código de site completo",
        pwa_reward: "Recompensas PWA"
},
    dayList: {
        giftAmount:"Valor do presente",
        turnoverTimes:"Tempos de rotatividade",
        refundRatio:"Taxa de Reembolso"
    },
    activityStatus: {
        pending: "Pendente",
        completed: "Concluído",
        noRewards: "Sem recompensas"
    },
    pwaInstructions: {
        popupTitle: 'Clique em "Adicionar à Tela Inicial" para salvar na tela inicial do iPhone',
        btnText: "Baixar APP"
    },
    activity: {
    available: "Disponível",
    given: "Dado",
    total: "Total",
    today: "Hoje",
    click: "Clique",
    bettingAmount: "Valor da aposta",
    cashBackTotal: "Total de reembolso",
    details: "Detalhes",
    lossTotal:"Perda total",
    givenAmount: "Quantidade dada"
},
games:{
    favorite : "Favorito"
},
recharge:{
    CumulativeReachargeAmount:"Valor de recarga cumulativa",
    giveAway: "Valor do presente",
    giftAmountText: "Recompensa de recarga para cada recarga:"
},
betting:{
    CumulativeBettingAmount:"Valor da aposta cumulativa",
    giftAmountText: "Recompensa de aposta para cada aposta:"
},
commission:{
    recharge:"Comissão de recarga",
    betting:"Comissão de Apostas"
}
};
